import { useBaseStore } from '@store';

import { ErrorScreen, LoginScreen, UpdateCredentialsScreen } from '../../screens';

export const AppRouter = () => {
	const visibleScreen = useBaseStore((state) => state.visibleScreen);

	return (
		<>
			{visibleScreen === 'login' && <LoginScreen />}
			{visibleScreen === 'error' && <ErrorScreen />}
			{visibleScreen === 'updateCredentials' && <UpdateCredentialsScreen />}
		</>
	);
};
